var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscordLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 39,
    viewBox: "0 0 46 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_447_441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8122 9.94203C31.082 9.14816 29.2274 8.56351 27.2879 8.22878C27.2529 8.22199 27.2178 8.23895 27.1986 8.27062C26.96 8.69469 26.6954 9.24881 26.511 9.68306C24.4246 9.37094 22.3495 9.37094 20.306 9.68306C20.1217 9.23863 19.8469 8.69469 19.6083 8.27062C19.5891 8.23895 19.554 8.22312 19.5189 8.22878C17.5806 8.56238 15.726 9.14703 13.9947 9.94203C13.98 9.94768 13.9664 9.95899 13.9585 9.97256C10.4404 15.2288 9.47578 20.3561 9.94848 25.4201C9.95074 25.445 9.96431 25.4687 9.98354 25.4834C12.3052 27.1888 14.5533 28.2235 16.7608 28.9088C16.7958 28.9201 16.8331 28.9065 16.8558 28.8771C17.3782 28.1647 17.843 27.4127 18.2422 26.6222C18.2659 26.5758 18.2433 26.5204 18.1947 26.5023C17.4563 26.2219 16.754 25.8804 16.0777 25.4936C16.0246 25.4619 16.0201 25.3862 16.0687 25.3489C16.2112 25.2426 16.3537 25.1317 16.4894 25.0198C16.5142 24.9994 16.5482 24.9949 16.5776 25.0085C21.0196 27.0361 25.828 27.0361 30.2169 25.0085C30.2463 24.9949 30.2802 24.9983 30.3062 25.0198C30.4419 25.1317 30.5844 25.2437 30.728 25.35C30.7778 25.3862 30.7744 25.4631 30.7201 25.4947C30.0438 25.8894 29.3416 26.2241 28.602 26.5023C28.5534 26.5204 28.533 26.577 28.5556 26.6233C28.9627 27.4127 29.4287 28.1647 29.9409 28.8771C29.9624 28.9077 30.0009 28.9201 30.0359 28.9099C32.2535 28.2235 34.5028 27.1888 36.8233 25.4846C36.8437 25.4699 36.8561 25.4472 36.8584 25.4224C37.4238 19.5679 35.9107 14.4824 32.8461 9.97482C32.8405 9.95899 32.8269 9.94768 32.8122 9.94203ZM18.906 22.3374C17.5682 22.3374 16.4668 21.1093 16.4668 19.6018C16.4668 18.0944 17.5467 16.8663 18.906 16.8663C20.2755 16.8663 21.3668 18.1046 21.3453 19.6018C21.3453 21.1104 20.2642 22.3374 18.906 22.3374ZM27.9246 22.3374C26.5879 22.3374 25.4854 21.1093 25.4854 19.6018C25.4854 18.0944 26.5653 16.8663 27.9246 16.8663C29.2941 16.8663 30.3854 18.1046 30.3639 19.6018C30.3639 21.1104 29.2941 22.3374 27.9246 22.3374Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_447_441",
    x: 0.836426,
    y: 0.227295,
    width: 45.1387,
    height: 38.686,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_447_441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_447_441",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordLogo);
export default __webpack_public_path__ + "static/media/discord-logo.fda069a8644ad0577e670d50f48b51c9.svg";
export { ForwardRef as ReactComponent };